"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/**
 * Returns a copy of `value` that only updates after `delayMs` of no changes.
 * Used to keep network calls (search/suggestions) off the hot path of every keystroke.
 */
export function useDebouncedValue(value, t0) {
  const $ = _c(4);
  const delayMs = t0 === undefined ? 350 : t0;
  const [debounced, setDebounced] = useState(value);
  let t1;
  let t2;
  if ($[0] !== delayMs || $[1] !== value) {
    t1 = () => {
      const timer = setTimeout(() => setDebounced(value), delayMs);
      return () => clearTimeout(timer);
    };
    t2 = [value, delayMs];
    $[0] = delayMs;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return debounced;
}